export default "__VITE_ASSET__32fc192b__"